import React from 'react';
//import styled from 'styled-components';
import { Page, PageContent, PageHeader, Footer, Text } from 'grommet';
//import { Hpe as HpeIcon } from 'grommet-icons';
import Iframe from 'react-iframe';
import { AppFooter } from '../components';

const SaaSPage = () => {

  //const [value, setValue] = React.useState('');
  //const size = useContext(ResponsiveContext);
  //const [focused] = useState(false);
  //const [focused, setFocused] = useState(false);

  return (

    <Page background="background-back" flex="grow">

      <PageContent height="100%">
        <PageHeader title="SaaS Value Chain" size="small"
          pad={{ vertical: 'small' }}
          subtitle={`Your one stop shop to understand E2E SaaS operations.`}
        />

        <Iframe url="https://onenr.io/0ZQWky9N9QW"
          width="100%"
          height="100%"
          border="0px"
          id=""
          className=""/>

      </PageContent>

      <Footer pad="xsmall" justify="center">
        <Text size="11pt" style={{fontStyle: 'italic', fontWeight: 'bold'}}>Powered by ITaaS</Text>
      </Footer>

      <AppFooter />

    </Page>

  );
};

export { SaaSPage as SaaS };